import { action, makeObservable, observable } from 'mobx';

export class CrossTableHoverStore {
    @observable hoveredRowId: string | undefined = undefined;
    @observable selectedRowId: string | undefined = undefined;

    constructor() {
        makeObservable(this);
    }

    @action
    setHoveredRowId(id: string | undefined) {
        this.hoveredRowId = id;
    }

    @action
    setSelectedRowId(id: string | undefined) {
        this.selectedRowId = id;
    }
}
